import React from "react";
import Hero from "../Hero";
import Banner from "../Section/BannerSection";
import Section from "../Section";
import FeaturesSection from "../Section/FeaturesSection";
import BlogSection from "../Section/BlogSection";
import AppointmentSection from "../Section/AppointmentSection";
import DepartmentSection from "../Section/DepartmentSection";
import { pageTitle } from "../../helpers/PageTitle";
const featureListData = [
  {
    iconSrc: "/images/home_1/compassion.svg",
    title: "Senyum",
    subTitle:
      "Senyum adalah awal dari pelayanan yang ramah. Senyuman tulus dari tenaga medis dan staf rumah sakit dapat memberikan rasa nyaman dan tenang kepada pasien yang sedang dalam perawatan.",
  },
  {
    iconSrc: "/images/home_1/excellence.svg",
    title: "Salam",
    subTitle:
      "Memberikan salam dengan hangat kepada pasien dan keluarga mereka menunjukkan rasa hormat dan kepedulian. Salam yang tulus menciptakan kesan pertama yang positif dan memperkuat hubungan antar manusia.",
  },
  {
    iconSrc: "/images/home_1/integrity.svg",
    title: "Sapa",
    subTitle: `Sapalah pasien dengan nama mereka dan berikan perhatian penuh saat berinteraksi. Sapaan yang hangat dan penuh perhatian membuat pasien merasa diperhatikan dan dihargai sebagai individu.`,
  },
  {
    iconSrc: "/images/home_1/respect.svg",
    title: "Sopan",
    subTitle:
      "Kesopanan dalam berbicara dan bertindak adalah cerminan dari profesionalisme. Bertindak sopan kepada pasien dan keluarga mereka menunjukkan bahwa kita menghargai martabat dan hak mereka.",
  },
  {
    iconSrc: "/images/home_1/teamwork.svg",
    title: "Santun",
    subTitle:
      "Kesantunan dalam setiap tindakan dan komunikasi menciptakan suasana yang tenang dan nyaman. Berbicara dengan nada yang lembut dan tindakan yang penuh perhatian membuat pasien merasa lebih tenang dan dihargai.",
  },
];
const blogData = [
  {
    title:
      "RS. Mutiara Bunda gelar bakti sosial opearasi bibir sumbing dan langit-langit gratis.",
    thumbUrl: "images/blog/op.jpg",
    date: "20 Juli 2024",
    btnText: "Selengkapnya",
    href: "/blog/blog200724'",
    socialShare: true,
  },
  {
    title: "Healthy Eating on a Budget: Tips and Strategies",
    thumbUrl: "images/home_1/post_2.jpeg",
    date: "May 4, 2023",
    btnText: "Learn More",
    href: "/blog/blog-details",
    socialShare: true,
  },
  {
    title: "The Importance of Regular Cancer Screenings and Early Detection",
    thumbUrl: "images/home_1/post_3.jpeg",
    date: "May 1, 2023",
    btnText: "Learn More",
    href: "/blog/blog-details",
    socialShare: true,
  },
];
const departmentData = [
  {
    title: "Instalasi Gawat Darurat 24 Jam",
    iconUrl: "images/home_1/emergency.svg",
    href: "/departments/department-details",
  },
  {
    title: "Laboratorium",
    iconUrl: "images/departments/lab.svg",
    href: "/departments/department-details",
  },
  {
    title: "Poliklinik",
    iconUrl: "images/departments/poli.svg",
    href: "/departments/department-details",
  },
  {
    title: "Medical Check Up",
    iconUrl: "images/departments/mcu.svg",
    href: "/departments/department-details",
  },
  {
    title: "Fisioterapi",
    iconUrl: "images/departments/fisio.svg",
    href: "/departments/department-details",
  },
  {
    title: "Rawat Inap",
    iconUrl: "images/departments/inap.svg",
    href: "/departments/department-details",
  },
];

export default function Home() {
  pageTitle("Beranda");
  return (
    <>
      <Hero
        title="Rumah Sakit<br>
        Mutiara Bunda"
        subTitle="Melayani dengan sepenuh hati"
        bgUrl="/images/home_1/hero_bg.png"
        imgUrl="/images/home_1/head.png"
        videoBtnText=""
        videoUrl="https://www.youtube.com/embed/X4YZI2LEAz4" //embed......
        infoList={[
          {
            title: "Pendaftaran",
            subTitle: "081369167220",
            iconUrl: "/images/contact/icon_1.svg",
          },
          {
            title: "Panggilan Darurat",
            subTitle: "082372589265",
            iconUrl: "/images/icons/ambulance.svg",
          },
          {
            title: "Alamat",
            subTitle: "Jalan Lintas Timur No.1147 Unit II",
            iconUrl: "/images/icons/pin.svg",
          },
        ]}
        btnText="Buat janji Temu"
        btnUrl="/appointments"
      />
      {/* Start Feature Section */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection
          sectionTitle="Budaya Kami 5S "
          data={featureListData}
        />
      </Section>
      <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle="Fasilitas & Layanan"
          bgUrl="images/home_1/department_bg.png"
          data={departmentData}
        />
      </Section>
      {/* End Departments Section */}
      {/* Start Award Section */}
      <Section topMd={185} topLg={140} topXl={100}></Section>
      {/* End Award Section */}
      {/* Start Testimonial */}
      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.png"
          imgUrl="images/home_1/cta_img.png"
          title="Jangan Biarkan Kesehatanmu Terabaikan! "
          subTitle="Jadwalkan janji temu dengan profesional medis berpengalaman kami hari ini!"
        />
      </Section>
      {/* End Banner Section */}
      {/* Start Blog Section */}
      {/* End Blog Section */}
      {/* Start Appointment Section */}
      <Section topMd={190} topLg={145} topXl={105} id="appointment">
        <AppointmentSection
          sectionTitle="Janji Temu"
          sectionTitleUp="Jadwalkan"
          imgUrl="/images/home_1/janji.png"
        />
      </Section>
      {/*    <Section topMd={190} topLg={145} topXl={105}>
        <BlogSection
          sectionTitle="Update Terbaru"
          sectionTitleUp="Berita & Artikel"
          data={blogData}
        />
      </Section>{" "}
      End Appointment Section */}
      <Section topMd={185} topLg={140} topXl={100}></Section>
    </>
  );
}
